// Konfigurasi armada berdasarkan tipe.
export const TRUCK_TYPES = [
  'Mobil 4 Roda',
  'Truk 6 Roda',
  'Truk 10 Roda',
  'Truk 12 Roda',
  'Truk Single Vessel',
];

const CONFIGS = {
  'Mobil 4 Roda': {
    wheels: 4,
    axles: [
      { name: 'GARDAN DEPAN', positions: [1, 2], wheelCount: 2 },
      { name: 'GARDAN BELAKANG', positions: [3, 4], wheelCount: 2 },
    ],
  },
  'Truk 6 Roda': {
    wheels: 6,
    axles: [
      { name: 'GARDAN 1', positions: [1, 2], wheelCount: 2 },
      { name: 'GARDAN PENGGERAK', positions: [3, 4, 5, 6], wheelCount: 4 },
    ],
  },
  'Truk 10 Roda': {
    wheels: 10,
    axles: [
      { name: 'GARDAN 1', positions: [1, 2], wheelCount: 2 },
      { name: 'GARDAN PENGGERAK 1', positions: [3, 4, 5, 6], wheelCount: 4 },
      { name: 'GARDAN PENGGERAK 2', positions: [7, 8, 9, 10], wheelCount: 4 },
    ],
  },
  'Truk 12 Roda': {
    wheels: 12,
    axles: [
      { name: 'GARDAN 1', positions: [1, 2], wheelCount: 2 },
      { name: 'GARDAN 2', positions: [3, 4], wheelCount: 2 },
      { name: 'GARDAN PENGGERAK 1', positions: [5, 6, 7, 8], wheelCount: 4 },
      { name: 'GARDAN PENGGERAK 2', positions: [9, 10, 11, 12], wheelCount: 4 },
    ],
  },
  'Truk Single Vessel': {
    wheels: 26,
    axles: [
      { name: 'DRIVE', positions: [1, 2], wheelCount: 2 },
      { name: 'DRIVE 1', positions: [3, 4, 5, 6], wheelCount: 4 },
      { name: 'DRIVE 2', positions: [7, 8, 9, 10], wheelCount: 4 },
      { name: 'VESSEL 1', positions: [11, 12, 13, 14], wheelCount: 4 },
      { name: 'VESSEL 2', positions: [15, 16, 17, 18], wheelCount: 4 },
      { name: 'VESSEL 3', positions: [19, 20, 21, 22], wheelCount: 4 },
      { name: 'VESSEL 4', positions: [23, 24, 25, 26], wheelCount: 4 },
    ],
  },
};

// Legacy aliases — old trucks with these types fall back to a 12-wheel layout.
const LEGACY_FALLBACK = {
  'Rigid': 'Truk 12 Roda',
  'Dump Truck 12 Roda': 'Truk 12 Roda',
  'Trailer': 'Truk 12 Roda',
  'Prime Mover': 'Truk 12 Roda',
};

export function getTruckConfig(truckType) {
  if (CONFIGS[truckType]) return CONFIGS[truckType];
  const fallback = LEGACY_FALLBACK[truckType];
  if (fallback) return CONFIGS[fallback];
  return CONFIGS['Truk 12 Roda'];
}

export function normalizeTruckType(truckType) {
  if (CONFIGS[truckType]) return truckType;
  return LEGACY_FALLBACK[truckType] || truckType || 'Lainnya';
}
